import { Outlink } from "./Outlink";
import { renderOutro } from "./OutroLogic";
import OutroOverlay from "./OutroOverlay";
import { Question } from "./Question";

export type OutroPropsExtented = {
  onClose: () => void;
  withTopPadding?: boolean;
};

export { Outlink, OutroOverlay, Question, renderOutro };
